import React, {useState, useRef, useMemo, useCallback, useEffect} from 'react';
import Button from 'devextreme-react/button';
import  TextBox from 'devextreme-react/text-box';
import CheckBox from 'devextreme-react/check-box';
import notify from 'devextreme/ui/notify';
import { SingleCard } from '../../layouts';
import { formatMessage } from "devextreme/localization";
import { formatMessageExt } from "../../utils/helpers";
import { useAppState } from "../../contexts/app-state";
import Validator, { RequiredRule } from 'devextreme-react/validator';
import ValidationGroup from 'devextreme-react/validation-group';
import {Alert, GoogleRecaptcha, PasswordText} from '../../components';
import { useFormData } from '../../utils/form-data';

const getStoredLoginName = () => (window.localStorage ? localStorage.getItem('loginName') : '') ?? ''

const createFormData = () => {
    // adnroid WebView da localStorage kapalı gelebiliyor.
    // bu kısım sadece cep telefonunda google hesabı eklede hatırlamasına gerek yok
    // localStorage.getItem() değer yoksa null döndürür
    let storedLoginName =  getStoredLoginName()

    return {
        loginName : storedLoginName ? storedLoginName : '',
        passwd : '',
        rememberMe: !!storedLoginName,
        captchaResponse: false,
    };
}

const errorsInit = () => { return  { message : false, login : false, password : false, captcha: false } };

const saveRememberMeState = (rememberMe, loginName) => {
    if (window.localStorage) {
        const key = 'loginName';
        if(rememberMe) {
            localStorage.setItem(key, loginName);
        } else {
            if(localStorage.getItem(key)) {
                localStorage.removeItem(key);
            }
        }
    }
}

export default function ({ sifreDegistir, mfaDogrula, mfaSecim }) {
    // const history = useHistory();
    const { state } = useAppState();
    const [isBusy, setIsBusy] = useState(false);
    const [error, setError] = useState(()=> errorsInit());
    const [showCaptcha, setShowCaptcha] = useState(false);
    const { formData, setInputValue, inputChangeHandler } = useFormData(createFormData());
    const refScrollView = useRef(null);
    const refValidationGroup = useRef(null);
    const refUserName = useRef(null);
    const refPassword = useRef(null);
    const refButton = useRef(null);
    const refRecaptcha = useRef(null);

    const focusUserName = useCallback(() => {
        if (refUserName.current) {
            refUserName.current.instance.focus()
        }
    }, [])

    const focusPassword = useCallback(() => {
        if (refPassword.current) {
            refPassword.current.instance.focus()
        }
    }, [])

    const setFocusState = useCallback(() => {
        if (formData.loginName === '') {
            focusUserName()
        } else if (formData.passwd === '') {
            focusPassword()
        }
    }, [focusUserName, focusPassword, formData.loginName, formData.passwd])

    useEffect(()=> setFocusState() , [setFocusState])

    const sayfaAyar = useMemo(()=> state.pages.find(e => e.component === 'OturumAcSayfa'), [state.pages]);

    const displayCaptcha = useCallback(
        () => (sayfaAyar && sayfaAyar.showCaptcha) || showCaptcha
    , [sayfaAyar, showCaptcha])

    const rememberMeChanged = useCallback((e) => {
        saveRememberMeState(e.value, formData.loginName)
        setInputValue('rememberMe', e.value);
        setFocusState()
    }, [setFocusState, formData.loginName, setInputValue])

    //const isValid = () => refValidationGroup.current.instance.validate().isValid;
    const oturumAc  = useCallback(() => {
        if (!refValidationGroup.current.instance.validate().isValid) {
            return;
        }

        if (displayCaptcha() && !formData.captchaResponse) {
            setError({...error, captcha: formatMessage('validation.robot') });
            return;
        }

        setError(errorsInit());
        setIsBusy(true);

        const { loginName, passwd, captchaResponse, rememberMe } = formData;
        const data = displayCaptcha()
            ? { loginName, passwd, captchaResponse}
            : { loginName, passwd};

        fetch("/ui/login",
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json'},
                body: JSON.stringify(data)
            })
            .then((response) => response.json())
            // .then((responseJson) => {
            //     if (state.debug) {
            //         console.error(responseJson)
            //     }
            //     return JSON.parse(responseJson)
            //     //response.json()
            // })
            .then((res) => {
                if (res.success) {
                    if (res.action === 'resume') {
                        saveRememberMeState(rememberMe, loginName);
                        window.location = '/resume';
                    } else if (res.action === 'mfa_choice') {
                        mfaSecim(res)
                    } else if (res.action === 'mfa_validation') {
                        mfaDogrula(res)
                    } else if (res.action === 'change_password') {
                        sifreDegistir(res)
                        // TODO:  Parola değiştir sebebi açıklaması gösterilerek kullanıcıya şifre değişikliğine zorlama
                        //  Sonraki oturum açmada parola değiştirsin işaretli veya kullanım süresi dolduğunda
                    } else if(res.action === 'show-agreement') {
                        // TODO: Kurumun e posta veya kimlik hesabı kullanım sözleşmesi kullanıcı tarafından daha önce
                        //  onaylanmamış ise sözleşmeyi okut imzalat
                    } else if (res.action === 'create-account') {
                        // TODO: Oluşturulmamış açılacak hesap ise hesap oluşturma sihirbazı görüntülensin
                    }
                } else {
                    setInputValue('captchaResponse', false);
                    setError(res.error);
                    setShowCaptcha(res.showCaptcha);
                    //this.props.setState({...res, password: '', captchaResponse: false, isBusy:false });
                    if(refRecaptcha.current) {
                        refRecaptcha.current.reset();
                    }
                    if (refPassword.current && refPassword.current.instance) {
                        // refPassword.current.instance.reset();
                        refPassword.current.instance.focus();
                    }
                    setIsBusy(false);
                    if (refScrollView.current) {
                        refScrollView.current.instance
                            .scrollToElement(document.querySelector('#kq-header'));
                    }
                }
            })
            .catch((error) => {
                notify(formatMessage('oops'), "error", 2000);
                if (state.debug) {
                    console.error(error);
                }
                setIsBusy(false);
            });
    }, [displayCaptcha, error, formData, mfaDogrula, mfaSecim, setInputValue, sifreDegistir, state.debug])

    const loginName_onKeyDown = useCallback((e) => {
        /* Enter Press */
        if (e.event.which === 13) {
            e.event.preventDefault();
            focusPassword()
        }
    }, [focusPassword])

    const password_onKeyDown = useCallback((e) => {
        /* Enter */
        if (e.event.which === 13) {
            e.event.preventDefault();
            if (refButton.current && refButton.current.instance) {
                // refPassword.current.instance.reset();
                refButton.current.instance.focus();
            }
            oturumAc();
        }
    }, [refButton, oturumAc])

    // console.log(['render card', state.showCaptcha, showCaptcha])
    return (
        <SingleCard disabled={isBusy}
                    ref={refScrollView}
                    page="OturumAcSayfa"
                    title={formatMessage('oturumAc.baslik')}>
            {error.message && <Alert type="error"
                                     iconClass="fa fa-2x fa-exclamation-circle"
                                     message={error.message} />}
            <div className={isBusy ? 'kq-progress-line' : 'kq-line'}/>
            <ValidationGroup ref={refValidationGroup}>
            <div className="kq-form login-form">
                <TextBox placeholder={formatMessage('kullaniciAdi')}
                         readOnly={isBusy}
                         ref={refUserName}
                         defaultValue={formData.loginName}
                         valueChangeEvent="keyup blur"
                         autoComplete="off"
                         focusStateEnabled={true}
                         onKeyDown={loginName_onKeyDown}
                         onValueChanged={inputChangeHandler('loginName')}
                         stylingMode={'filled'}>
                    <Validator>
                        <RequiredRule message={formatMessageExt('validation.isRequired', ['kullaniciAdi'])} />
                    </Validator>
                </TextBox>

                <br />
                <PasswordText placeholder={formatMessage('sifre')}
                              ref={refPassword}
                              readOnly={isBusy}
                              onKeyDown={password_onKeyDown}
                              defaultValue={formData.passwd}
                              displayButton={true}
                              onValueChanged={inputChangeHandler('passwd')}
                >
                    <Validator>
                        <RequiredRule message={formatMessageExt('validation.isRequired', ['sifre'])} />
                    </Validator>
                </PasswordText>

                <br/>
                <div>
                    <CheckBox text={formatMessage('oturumAc.beniHatirla')}
                              defaultValue={formData.rememberMe}
                              readOnly={isBusy}
                              onValueChanged={rememberMeChanged}
                              className="form-text" />
                </div>

                {displayCaptcha() && <div>
                    <br/>
                    <GoogleRecaptcha ref={refRecaptcha}
                                 setInputValue={setInputValue}
                                 error={error.captcha}/>
                </div>}

                <br/>
                <Button ref={refButton} width="100%" type="default" disabled={isBusy} onClick={oturumAc}>
                <span className="dx-button-text">
                    { formatMessage('oturumAc.giris') }
                </span>
                </Button>
            </div>
        </ValidationGroup>
        </SingleCard>
    );
}
